import { render } from "./OidoModalContent.vue?vue&type=template&id=1627d22e&scoped=true"
import script from "./OidoModalContent.vue?vue&type=script&lang=js"
export * from "./OidoModalContent.vue?vue&type=script&lang=js"

import "./OidoModalContent.vue?vue&type=style&index=0&id=1627d22e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1627d22e"]])

export default __exports__